import { UrlMappingsKeys } from '@wix/url-mapper-utils';

export const getCustomPostUrlData = (slug) => {
  return { key: UrlMappingsKeys.BLOG_POST, variables: { slug } };
};

export const getCustomPostEditUrlData = (id) => {
  return { key: UrlMappingsKeys.BLOG_POST_EDIT, variables: { slug: id } };
};
